import React, { useEffect, useState } from 'react'
import { LinkButton } from '@zera-admin/button'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Page, { PageHeader } from '@zera-admin/page'
import Table from '@zera-admin/table'

import Pager from 'components/pager'
import MainLayout from 'layouts/main'
import entityTypesService, {
  EntityType,
  EntityTypeResponse,
} from 'services/http/dataset/entity-type'

import { EntityTypeListProps } from './types'

const EntityTypeList: React.FunctionComponent<EntityTypeListProps> = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [entityType, setEntityType] = useState<EntityTypeResponse>()

  useEffect(() => {
    getEntityTypes()
  }, [])

  const getEntityTypes = async () => {
    try {
      const response = await entityTypesService.get()

      setEntityType(response.data)
      setIsLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  const renderPageHeader = () => {
    const actions = (
      <LinkButton appearance="primary" href="/entity-type/create">
        Varlık tipi oluştur
      </LinkButton>
    )

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="Varlık tipi" />
      </Breadcrumb>
    )

    const bottomBar = (
      <p>
        Tüm varlık tiplerini görüntüleyebilir, yeni oluşturabilir, varolanları
        düzenleyebilirsiniz.
      </p>
    )

    return (
      <PageHeader
        actions={actions}
        bottomBar={bottomBar}
        breadcrumbs={breadcrumbs}
      >
        Varlık tipi
      </PageHeader>
    )
  }

  const renderPageTable = () => {
    const columns = [
      {
        name: 'name',
        text: 'Varlık tipi metni',
      },
      {
        name: 'longName',
        text: 'Uzun varlık tipi metni',
      },
      {
        name: 'operation',
        text: 'İşlemler ',
        width: '100px',
        render: (item: EntityType) => (
          <LinkButton
            appearance="subtle-link"
            href={`/entity-type/update/${item.id}`}
          >
            Görüntüle
          </LinkButton>
        ),
      },
    ]

    if (entityType) {
      return (
        <React.Fragment>
          <Table
            columns={columns as any}
            rows={entityType.list}
            isLoading={isLoading}
            helperMessage="Aradığınız kriterlere uygun bir veri bulunamadı"
          />
          <Pager pages={entityType.pageCount} />
        </React.Fragment>
      )
    }

    return null
  }

  return (
    <MainLayout>
      <Page>
        {renderPageHeader()}
        {renderPageTable()}
      </Page>
    </MainLayout>
  )
}

export default EntityTypeList
